<template>
  <div class="services">
    <div class="site-content">
      <div
        class="page-header"
        :style="{backgroundImage:`url(${require('../assets/images/subheader-6.jpg')})`}"
        style="background:no-repeat center center;"
      >
        <div class="container">
          <div class="breadc-box no-line">
            <div class="row">
              <div class="col-md-12">
                <h2 class="page-title">客户案例</h2>
                <ul id="breadcrumbs" class="breadcrumbs none-style">
                  <li>
                    <router-link :to="{name: 'home'}" class="active_item" exact>首页</router-link>
                  </li>
                  <li class="active">客户案例</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section>
        <div class="container">
          <div class="row">
            <!-- <div class="col-md-12">
							<h4 class="text-primary"></h4>
							<h2></h2>
							<br>
            </div>-->
            <div class="col-md-12">
              <div class="project-filter" data-column>
                <div id="projects" class="project-grid projects row">
                  <div
                    class="project-item construction col-md-4 col-sm-6"
                    v-for="(item,index) in projects"
                    :key="index">
                    <div class="inner">
                      <img :src="item.image" :alt="item.name" />
                      <div class="project-info">
                        <div class="project-content">
                          <h3>{{item.name}}</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "project",
  components: {},
  data() {
    return {
      projects: [],
    };
  },
  created() {
    let that = this;
    //数据请求
    this.$axios
      .get("/static/data.json")
      .then(function (response) {
        console.log(response);
        that.projects = response.data.data.projects;
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  methods: {},
};
</script>

<style>
.project-item {
  height: 300px;
  line-height: 300px;
  vertical-align: middle;
  text-align: center;
}
.project-item img {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/pages/project.vue